/* Boutiques carousel — auto-advances through the vendor cards, looping, and
   pauses while the shopper is interacting. Reduced-motion users get a plain
   swipeable rail with no auto-play. */
(function () {
  function init(root) {
    if (root.dataset.jyVcInit) return;
    root.dataset.jyVcInit = '1';

    var rail = root.querySelector('[data-jy-vcarousel-rail]');
    if (!rail) return;
    var cells = Array.prototype.slice.call(rail.children);
    if (cells.length < 2) return;

    var dotsWrap = root.querySelector('[data-jy-vcarousel-dots]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* how many cells fit in the viewport → number of "pages" for the dots */
    function perView() {
      var cw = cells[0].getBoundingClientRect().width || 1;
      return Math.max(1, Math.round(rail.clientWidth / cw));
    }

    var dots = [];
    function buildDots() {
      if (!dotsWrap) return;
      var pages = Math.max(1, cells.length - perView() + 1);
      dotsWrap.innerHTML = '';
      dots = [];
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-i', i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function currentIndex() {
      var cw = cells[0].getBoundingClientRect().width + railGap();
      return Math.round(rail.scrollLeft / cw);
    }
    function railGap() {
      var g = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '0');
      return isNaN(g) ? 0 : g;
    }
    function paintDots() {
      if (!dots.length) return;
      var idx = Math.min(currentIndex(), dots.length - 1);
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === idx);
    }

    function goTo(i) {
      var cw = cells[0].getBoundingClientRect().width + railGap();
      var max = cells.length - perView();
      if (i > max) i = 0;
      if (i < 0) i = max;
      rail.scrollTo({ left: Math.round(i * cw), behavior: 'smooth' });
    }

    var paused = false;
    var pauseUntil = 0;
    function hold() {
      pauseUntil = Date.now() + 9000;
    }
    rail.addEventListener('scroll', paintDots, { passive: true });
    rail.addEventListener('pointerdown', hold, { passive: true });
    rail.addEventListener('touchstart', hold, { passive: true });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-i]');
        if (!b) return;
        hold();
        goTo(parseInt(b.getAttribute('data-i'), 10) || 0);
      });
    }

    buildDots();
    paintDots();

    var ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(function () { buildDots(); paintDots(); });
      ro.observe(rail);
    }

    if (!reduced) {
      setInterval(function () {
        if (paused || document.hidden) return;
        if (Date.now() < pauseUntil) return;
        if (!rail.clientWidth || rail.offsetParent === null) return;
        goTo(currentIndex() + 1);
      }, interval);
    }
  }

  function boot() {
    document.querySelectorAll('[data-jy-vcarousel]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', boot);
})();
